import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcSubmit = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M14.154 2.313a1 1 0 0 0-.982-.813h-2.345a1 1 0 0 0-.983.813l-.18.95c-.07.365-.34.658-.688.79A8.491 8.491 0 0 0 6.63 5.41a1.075 1.075 0 0 1-1.028.2l-.915-.319a1 1 0 0 0-1.195.444L2.32 7.766a1 1 0 0 0 .212 1.257l.733.632c.282.243.4.623.341.99a8.56 8.56 0 0 0 0 2.71c.06.367-.06.746-.341.99l-.733.632a1 1 0 0 0-.212 1.257l1.172 2.03a1 1 0 0 0 1.195.445l.915-.319c.352-.122.74-.035 1.028.2a8.492 8.492 0 0 0 2.346 1.357c.348.132.618.425.687.79l.181.95a1 1 0 0 0 .983.813h2.345a1 1 0 0 0 .982-.813l.18-.95c.07-.365.34-.658.689-.79a8.492 8.492 0 0 0 2.344-1.356 1.075 1.075 0 0 1 1.028-.2l.916.32a1 1 0 0 0 1.195-.445l1.173-2.03a1 1 0 0 0-.213-1.258l-.733-.632a1.076 1.076 0 0 1-.341-.99 8.559 8.559 0 0 0 0-2.712c-.06-.368.06-.747.341-.99l.733-.632a1 1 0 0 0 .213-1.257l-1.173-2.031a1 1 0 0 0-1.195-.444l-.916.319c-.352.122-.74.035-1.029-.2a8.49 8.49 0 0 0-2.343-1.356 1.076 1.076 0 0 1-.688-.79l-.181-.95Zm-3.918 6.584a.5.5 0 0 0-.737.44v5.326a.5.5 0 0 0 .737.44l4.945-2.663a.5.5 0 0 0 0-.88l-4.945-2.663Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcSubmit");

export { IcSubmit };
//# sourceMappingURL=ic-submit.js.map
